//const PropertyProjectInformationMaintenance = r => require.ensure([], () => r(require('@/page/propertyReportMge/PropertyProjectInformationMaintenance/PropertyProjectInformationMaintenance')), 'formulateReport');
const comprehensiveInquireMge = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/comprehensiveInquireMge')), 'comprehensiveInquireMge');
const comprehensiveInquireInfo = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/comprehensiveInquireInfo')), 'comprehensiveInquireInfo');

const propertyContractList = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/propertyContractList/propertyContractList')), 'propertyContractList');
const committeeContractList = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/committeeContractList/committeeContractList')), 'committeeContractList');
const companyTrainList = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/companyTrainList/companyTrainList')), 'companyTrainList');
const committeeExchangePaperList = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/committeeExchangePaper/committeeExchangePaperList')), 'committeeExchangePaperList');
const recordStatisticsList = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/recordStatisticsList/recordStatisticsList')), 'recordStatisticsList');
const recordCantonStatisticsList = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/recordCantonStatisticsList/recordCantonStatisticsList')), 'recordCantonStatisticsList');
const recordStreetStatisticsList = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/recordStreetStatisticsList/recordStreetStatisticsList')), 'recordStreetStatisticsList');
const recordCommunityStatisticsList = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/recordCommunityStatisticsList/recordCommunityStatisticsList')), 'recordCommunityStatisticsList');


const propertyRecordDetails = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/propertyRecordDetails/propertyRecordDetails')), 'propertyRecordDetails');
const committeeRecordDetails = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/committeeRecordDetails/committeeRecordDetails')), 'committeeRecordDetails');
const companyTrainDetail = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/companyTrainDetail/companyTrainDetail')), 'companyTrainDetail');
const committeeExchangePaperDetial = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/committeeExchangePaper/committeeExchangePaperDetial')), 'committeeExchangePaperDetial');

const projectDataList = r => require.ensure([], () => r(require('@/page/comprehensiveInquire/projectDataList/projectDataList')), 'projectDataList');

const comprehensiveInquireRouter = {
  path: '',
  component: comprehensiveInquireMge,
  meta: {
    icon: 'publicFundManagement',
    right: [],
    isShowMenu: true,
  },
  name: '综合查询管理',
  children: [{
      path: '/comprehensiveInquireInfo',
      component: comprehensiveInquireInfo,
      name: '信息综合查询',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:false,
      },
      children: [{
          path: '/propertyContractList',
          component: propertyContractList,
          name: '信息综合查询',
          meta: {
            name: '物业合同备案列表',
            right: ['物业合同备案列表'],
            isShowMenu: false,
            keepAlive:false,
          },
        },
        {
          path: '/committeeContractList',
          component: committeeContractList,
          name: '信息综合查询',
          meta: {
            name: '备案列表',
            right: ['备案列表'],
            isShowMenu: false,
            keepAlive:false,
          },
        },
        {
          path: '/committeeExchangePaperList',
          component: committeeExchangePaperList,
          name: '信息综合查询',
          meta: {
            name: '业主大会换证备案列表',
            right: ['业主大会换证备案列表'],
            isShowMenu: false,
            keepAlive:false,
          },
        },
        {
          path: '/companyTrainList',
          component: companyTrainList,
          name: '信息综合查询',
          meta: {
            name: '企业人员培训结果列表',
            right: ['企业人员培训结果列表'],
            isShowMenu: false,
            keepAlive:false,
          },
        },
        {
          path: '/recordStatisticsList',
          component: recordStatisticsList,
          name: '信息综合查询',
          meta: {
            name: '备案统计列表列表',
            right: ['备案统计列表列表'],
            isShowMenu: false,
            keepAlive:false,
          },
        },
        {
          path: '/recordCantonStatisticsList',
          component: recordCantonStatisticsList,
          name: '信息综合查询',
          meta: {
            name: '备案统计列表列表',
            right: ['备案统计列表列表'],
            isShowMenu: false,
            keepAlive:false,
          },
        },
        {
          path: '/recordStreetStatisticsList',
          component: recordStreetStatisticsList,
          name: '信息综合查询',
          meta: {
            name: '备案统计列表列表',
            right: ['备案统计列表列表'],
            isShowMenu: false,
            keepAlive:false,
          },
        },
        {
          path: '/recordCommunityStatisticsList',
          component: recordCommunityStatisticsList,
          name: '信息综合查询',
          meta: {
            name: '备案统计列表列表',
            right: ['备案统计列表列表'],
            isShowMenu: false,
            keepAlive:false,
          },
        },  
        {
          path: '/projectDataList',
          component: projectDataList,
          name: '信息综合查询',
          meta: {
            name: '项目数据统计',
            right: ['项目数据统计'],
            isShowMenu: false,
            keepAlive:false,
          },
        },
      ]
    },
    //这里写点击列表跳转路由
    {
      path: '/propertyRecordDetails',
      component: propertyRecordDetails,
      name: '物业合同备案详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:false,
      },
    },
    {
      path: '/committeeRecordDetails',
      component: committeeRecordDetails,
      name: '备案详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/companyTrainDetail',
      component: companyTrainDetail,
      name: '企业人员培训结果详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/committeeExchangePaperDetial',
      component: committeeExchangePaperDetial,
      name: '业主大会换证备案详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:false,
      },
    },
  ]

};

export default comprehensiveInquireRouter;
